import styled from "styled-components";

export const _VerticalSeparator = styled.div`
  @media (min-width: 1200px) {
    width: 1px;
    background: lightgrey;
  }
`;
